import React from 'react'
import { gql, graphql } from 'react-apollo'

import {
  Notifications,
  Loading,
} from 'components/UI'
import UserTable from './UserTable'


const ManagerUserList = ({ data }) => {
  const {
    error,
    loading,
    superintendents,
    organizations,
    refetch,
  } = data

  if (error) return <Notifications.Error message={error.message} />
  if (loading) return <Loading />

  const usersData = superintendents.map(({ id, ...rest }) => ({
    role: 'Superintendent',
    key: `user${id}`,
    id,
    ...rest,
  }))

  const organizationId = organizations[0].id

  return (
    <UserTable
      data={usersData}
      refetch={refetch}
      organizationId={organizationId}
    />
  )
}

const ManagerUserListQuery = gql`
  query ManagerUserListQuery {
    superintendents {
      id
      givenName
      familyName
      email
      buildings {
        id
      }
    }
    organizations {
      id
    }
  }
`

export default graphql(ManagerUserListQuery, {
  options: {
    notifyOnNetworkStatusChange: true,
  },
})(ManagerUserList)



// WEBPACK FOOTER //
// ./src/components/Profile/ManagerUserList.jsx